<div class="card">
  <div class="card-body">
    <h4 class="mb-3">Forgot Your Password?</h4>
    <p>No problem. Enter your email address below and we'll send a password reset email.</p>
    <form class="row" [formGroup]="forgotPasswordForm">
      <div class="form-group col-12">
        <label for="email">E-mail Address</label>
        <input
          type="text"
          id="email"
          formControlName="email"
          name="email"
          class="form-control"
          type="email"
          placeholder="jon@example.com"
          required
        >
      </div>
      <div class="col-12 text-center mb-4">
        <button
          [disabled]="this.forgotPasswordForm.invalid"
          class="btn btn-primary margin-bottom-none w-100"
          (click)="submit()"
        >Submit</button>
      </div>
    </form>
    <div class="link-style" [routerLink]="['/signin']">
      Back to Sign In
    </div>
  </div>
</div>